import { render, staticRenderFns } from "./appProduct.vue?vue&type=template&id=5c7fe98f"
import script from "./appProduct.vue?vue&type=script&lang=js"
export * from "./appProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports